module.exports = __webpack_public_path__ + "img/1457088404.dd0e3e66.jpg";